import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ConfigProvider, theme } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import App from './App'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: theme.darkAlgorithm,
        token: { colorPrimary: '#45d6c7', colorInfo: '#4ea4ff', colorBgBase: '#07101d', borderRadius: 8, fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif' },
        components: { Layout: { headerBg: '#08111f', siderBg: '#0a1422', bodyBg: '#060d18' }, Card: { colorBgContainer: '#0c1726' } },
      }}
    >
      <App />
    </ConfigProvider>
  </StrictMode>,
)

